module.exports = __webpack_public_path__ + "static/img/avatar2.b1258c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatar/avatar2.png
// module id = FRLh
// module chunks = 6